var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBunkering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#E8ECF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 22C51.5 19.6 50.1667 19 49.5 19H36.5V24.5L39.5 30.5V35.5L33.5 42.5V57.5C39.1 60.3 44.5 57.3333 46.5 55.5L49 53C49 53.3333 49.5 54.1 51.5 54.5C53.5 54.9 54.3333 53 54.5 52H61V43.5H54.5C54.1667 43.5 53.5 43.1 53.5 41.5C53.5 39.9 50.1667 40.1667 48.5 40.5L45 35.5C45.5 35 46.5 33.8 46.5 33C46.5 32 45.5 30.5 43.5 30.5C43.5 26.5 46.8333 24.8333 48.5 24.5C49.5 24.3333 51.5 23.6 51.5 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 40.5L32.5 35.5H44.5L49 41.5V54L46.5 55.1915C44.5 59.5 32.5 59.5 30.5 55.1915L28.5 54V40.5Z",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 43.5L54 42.5C54 41.1193 52.8807 40 51.5 40V40C50.1193 40 49 41.1193 49 42.5L49 52.5C49 53.8807 50.1193 55 51.5 55V55C52.8807 55 54 53.8807 54 52.5L54 52M54 43.5L60.5 43.5M54 43.5L54 52M54 52L60.5 52",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9996 30.5H33.9996C32.6189 30.5 31.4996 31.6193 31.4996 33V33C31.4996 34.3807 32.6189 35.5 33.9996 35.5H43.9996C45.3803 35.5 46.4996 34.3807 46.4996 33V33C46.4996 31.6193 45.3803 30.5 43.9996 30.5H43.4996M34.9996 30.5C34.9996 27.5 32.5 24 29.5 24M34.9996 30.5L43.4996 30.5M43.4996 30.5C43.4996 27.5 47 24 48.9998 24",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 51.5L23.5 52.5C23.5 53.8807 24.6193 55 26 55V55C27.3807 55 28.5 53.8807 28.5 52.5L28.5 42.5C28.5 41.1193 27.3807 40 26 40V40C24.6193 40 23.5 41.1193 23.5 42.5L23.5 43.5M23.5 51.5L16.5 51.5M23.5 51.5L23.5 43.5M23.5 43.5L16.5 43.5",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 19,
    width: 24,
    height: 5,
    rx: 2.5,
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBunkering);
export default __webpack_public_path__ + "static/media/icon-bunkering.e89994f2ea852321644a2b77b751a368.svg";
export { ForwardRef as ReactComponent };